module.exports = __webpack_public_path__ + "assets/checkbox-bg.5846f02a.svg";